import { useTranslation } from 'react-i18next';
import { APP_VERSION } from '../version';

/**
 * The foot of every page: whose application this is, and which commit is serving it. The version is the
 * build's own, not the running server's - one build is promoted between environments, so the number here
 * identifies the bundle in the browser.
 */
export function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="app-footer">
      <span className="mono" title={t('footer.versionHint')}>
        {t('footer.version', { version: APP_VERSION })}
      </span>
      <span>{t('footer.copyright', { year: new Date().getFullYear() })}</span>
    </footer>
  );
}
